import { configureStore } from '@reduxjs/toolkit';
import { projectsReducer } from '../features/projects/projectsSlice';
import { projectsApi } from '../features/projects/projectsApi';
import { climateApi } from '../features/climate/climateApi';
import onboardingReducer from '../features/onboarding/store/onboardingSlice';
import migrationReducer from '../features/migration/store/migrationSlice';

export const store = configureStore({
  reducer: {
    projects: projectsReducer,
    [projectsApi.reducerPath]: projectsApi.reducer,
    [climateApi.reducerPath]: climateApi.reducer,
    onboarding: onboardingReducer,
    migration: migrationReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      projectsApi.middleware,
      climateApi.middleware
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
